import { readCookie } from './readCookie';

const FBP_COOKIE = '_fbp';
const FBC_COOKIE = '_fbc';

export interface MetaCookies {
    fbp?: string;
    fbc?: string;
}

/**
 * Reads Meta's first-party attribution cookies so they can be forwarded to the
 * Conversions API alongside the event.
 *
 * `_fbp` identifies the browser and `_fbc` encodes the ad click that brought
 * the user here. For a logged-out visitor they are the strongest match signals
 * available, so a server-side event without them attributes far more poorly.
 *
 * Both are set by Meta's pixel, and seeded at the CDN edge from an `fbclid`
 * query parameter when the pixel is blocked. They must be sent unhashed.
 */
export function getMetaCookies(): MetaCookies {
    if (typeof document === 'undefined') {
        return {};
    }

    return {
        fbp: readCookie(FBP_COOKIE),
        fbc: readCookie(FBC_COOKIE),
    };
}
